/**
 * クライアント登録
 */

import React from 'react';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';
import zhCNLocale from 'date-fns/locale/zh-CN';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom'
import {
    Grid,
    InputLabel,
    InputBase,
    FormControlLabel,
    Select,
    MenuItem,
    Radio,
    RadioGroup,
    Button,
    FormControl,
    FormHelperText,
} from '@material-ui/core';
import { dictionary, getlangId } from 'mdoc/admin/axios'
import { getClientDetail } from 'mdoc/admin/axios/client'
import * as config from 'mdoc/admin/axios/config'
import { checkPNumber, checkInteger, ByteFormatToGB, GBFormatToByte, checkDecimal } from 'mdoc/utils';
import schema from 'async-validator';
import $ from 'jquery';
import { messageFormat, getLang, dateFormat } from 'mdoc/utils';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Clear } from '@material-ui/icons';
const localeMap = {
    1: jaLocale,
    2: zhCNLocale,
    3: enLocale,
};
const lang = getLang();

const BootstrapInput = withStyles(theme => ({
    root: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        },
        width: '130px'
    },
    input: {
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 12,
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapFormLabel: {
        lineHeight: '30px',
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    },
    Radio: {
        padding: '0px 10px'
    },
    required: {
        color: '#F72D2D'
    },
    button: {
        margin: theme.spacing.unit
    },
    addButton: {
        margin: theme.spacing.unit,
        borderRadius: '50%'
    },
    errorMsg: {},
    buttonLink: theme.palette.buttonLink,
});


const mapStateToProps = state => ({
    common: state.reducer.common,
    site: state.reducer.siteState || {},
    category: (state.reducer.categoryState || {}).site || {}
});

class Client_Add extends React.Component {
    state = {
        loading: false,
        selectedRowKeys: [], // Check here to configure the default column
        formData: {
            id: {
                value: '',
            },
            clientCode: {
                value: '',
                error: false,
                errorMsg: '',
                disabled: false
            },
            name: {
                value: '',
                error: false,
                errorMsg: ''
            },
            contactName: {
                value: '',
                error: false,
                errorMsg: ''
            },
            contactEmail: {
                value: '',
                error: false,
                errorMsg: ''
            },
            contactLangId: {
                width: '',
                value: '',
                error: false,
                errorMsg: ''
            },
            contactLangName: {
                width: '',
                value: '',
            },
            phone: {
                value: '',
                error: false,
                errorMsg: ''
            },
            fax: {
                value: '',
                error: false,
                errorMsg: ''
            },
            zipCode: {
                value: '',
                error: false,
                errorMsg: ''
            },
            address: {
                value: '',
                error: false,
                errorMsg: ''
            },
            capacity: {
                value: '',
                error: false,
                errorMsg: ''
            },
            startTimeStr: {
                value: null,
                error: false,
                errorMsg: ''
            },
            endTimeStr: {
                value: null,
                error: false,
                errorMsg: ''
            },
            managerCreate: {
                ruleId: config['RULE_CODE']['managerCreate'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            managerCreateNum: {
                value: '',
                error: false,
                errorMsg: ''
            },
            deputyManagerCreate: {
                ruleId: config['RULE_CODE']['deputyManagerCreate'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            deputyManagerCreateNum: {
                value: '',
                error: false,
                errorMsg: ''
            },
            userCreate: {
                ruleId: config['RULE_CODE']['userCreate'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            userCreateNum: {
                value: '',
                error: false,
                errorMsg: ''
            },
            departmentManagementAuth: {
                ruleId: config['RULE_CODE']['departmentManagementAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            categoryManagementAuth: {
                ruleId: config['RULE_CODE']['categoryManagementAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            newsRelease: {
                ruleId: config['RULE_CODE']['newsRelease'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            pushNotice: {
                ruleId: config['RULE_CODE']['pushNotice'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentRegistrationAuth: {
                ruleId: config['RULE_CODE']['contentRegistrationAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            deviceControl: {
                ruleId: config['RULE_CODE']['deviceControl'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentMultipleRegistration: {
                ruleId: config['RULE_CODE']['contentMultipleRegistration'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            logExport: {
                ruleId: config['RULE_CODE']['logExport'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            applicationImport: {
                ruleId: config['RULE_CODE']['applicationImport'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            activeDirectory: {
                ruleId: config['RULE_CODE']['activeDirectorySetting'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentUpdateEmailDelivery: {
                ruleId: config['RULE_CODE']['contentUpdateEmailDelivery'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentUpdatePushDelivery: {
                ruleId: config['RULE_CODE']['contentUpdatePushDelivery'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            loginKeepTimeFlg: {
                width: '',
                value: '0',
                error: false,
                errorMsg: ''
            },
            userLoginKeepTimeFlg: {
                width: '',
                value: '0',
                error: false,
                errorMsg: ''
            },
            adminUserCode: {
                value: '',
                error: false,
                errorMsg: '',
                disabled: false
            },
            contactPersonName: {
                value: '',
                error: false,
                errorMsg: ''
            },
            email: {
                value: '',
                error: false,
                errorMsg: ''
            },
            adminId: {
                value: '',
            },
            langId: {
                width: '',
                value: '',
                error: false,
                errorMsg: ''
            },
            langName: {
                width: '',
                value: '',
            },
            passValidTimeFlg:{
                width: '',
                value: '0',
                error: false,
                errorMsg: ''
            },
            userPassValidTimeFlg:{
                width: '',
                value: '0',
                error: false,
                errorMsg: ''
            },
        },
        // loading: false,
        dictWord: {
            'company_name': '',
            'contact_name': '',
            'contact_email': '',
            'tel_no': '',
            'fax_no': '',
            'zip_code': '',
            'address': '',
            'use_capacity': '',
            'service_start_date': '',
            'service_end_date': '',
            'enterprise_managers_generate': '',
            'enterprise_managers_count': '',
            'associate_managers_generate': '',
            'associate_managers_count': '',
            'user_generate': '',
            'user_count': '',
            'department_management_auth': '',
            'category_management_auth': '',
            'notification_release': '',
            'push_notice': '',
            'content_registration_auth': '',
            'device_control': '',
            'content_multiple_registration': '',
            'log_export': '',
            'login_save_period': '',
            'enterprise_managers_registration': '',
            'enterprise_managers_id': '',
            'contact_person_name': '',
            'email': '',
            'confirmation': '',
            'cancel': '',
            'msg_error_not_null_with_item': '',
            'msg_error_over_length_with_item': '',
            'valid': '',
            'invalid': '',
            'indefinitely': '',
            '3_months': '',
            '6_months': '',
            '12_months': '',
            '1_day': '',
            '1_week': '',
            '1_months': '',
            'msg_please_enter_halfwidth': '',
            'msg_please_enter_integer_than_1': '',
            'msg_please_enter_integer_than_0': '',
            'msg_error_record_exists': '',
            'msg_error_endate_greater_than_start_date': '',
            'msg_please_enter_halfwidth_num': '',
            'msg_not_valid_mail_address': '',
            'msg_please_enter_halfwidth_en_num': '',
            'set_lang': '',
            'contact_set_lang': '',
            'application_import': '',
            'active_directory_setting':'',
            'content_update_email_delivery':'',
            'content_update_push_delivery':'',
            'group_id':'',
            'managers_password_expires_period':'',
            'user_password_expires_period':'',
            'managers_login_save_period':'',
            'user_login_save_period':'',
            'msg_error_value_invalid': ''
        },
        lists: [''],
        loginKeepTimeFlg: config['LOGIN_KEEP_TIME'],
        userLoginKeepTimeFlg: config['LOGIN_KEEP_TIME'],
        passValidTimeFlg: config['PASS_VALID_TIME_FLG'],
        userPassValidTimeFlg: config['USER_PASS_VALID_TIME_FLG'],
        langIdData: [],
        langIdObj: {},
        contactLangIdObj: {},
    };

    componentWillMount() {
        this.start();
    }

    componentDidMount() {
        let formData = this.state.formData;
        formData['loginKeepTimeFlg'] = Object.assign(this.state['formData']['loginKeepTimeFlg'], { width: $('#endTimeStr').css('width') });
        formData['userLoginKeepTimeFlg'] = Object.assign(this.state['formData']['userLoginKeepTimeFlg'], { width: $('#endTimeStr').css('width') });
        formData['userPassValidTimeFlg'] = Object.assign(this.state['formData']['userPassValidTimeFlg'], { width: $('#endTimeStr').css('width') });
        formData['passValidTimeFlg'] = Object.assign(this.state['formData']['passValidTimeFlg'], { width: $('#endTimeStr').css('width') });
        formData['langId'] = Object.assign(this.state['formData']['langId']);
        formData['contactLangId'] = Object.assign(this.state['formData']['contactLangId']);
        this.setState({
            formData: formData
        });
    }

    start = () => {
        let dict = {}
        dictionary(this.state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
        getlangId().then(res => {
            let langIdData = this.state.langIdData
            let langIdObj = this.state.langIdObj
            let contactLangIdObj = this.state.contactLangIdObj
            let data = res.results
            for (let key in data) {
                let val = data[key];
                langIdData.push({
                    name: val.name,
                    id: val.id
                })
                langIdObj[val.id] = val.name;
                contactLangIdObj[val.id] = val.name;
            }

            this.setState({
                langIdData: langIdData,
                langIdObj: langIdObj,
                contactLangIdObj: contactLangIdObj,
            })
        })

        if (this.props.location.query !== undefined) {
            const confirmData = this.props.location.query;
            let formData = this.state.formData;
            for (let index in formData) {
                let value = confirmData[index];
                if (value !== undefined) {
                    if (['capacity'].includes(index)) {
                        value = ByteFormatToGB(value);
                    }

                    formData[index] = Object.assign(this.state['formData'][index], { value: value });
                }
            }

            this.setState({
                formData: formData,
            });
        }
        if (this.props.match.params.id !== undefined && this.props.location.query === undefined) {
            let id = this.props.match.params.id;
            let formData = this.state.formData;
            let contactLangName = Object.assign(this.state['formData']['applicationImport'], { value: '0' });
            formData['applicationImport'] = contactLangName;
            this.setState({
                loading: true,
                formData
            });
            getClientDetail(id).then(res => {
                const detail = res.results;
                let formData = this.state.formData;
                for (let index in formData) {
                    let formValue = formData[index];
                    if (formValue['ruleId'] !== undefined) {
                        let adminUserRules = detail['adminUserRules'];
                        for (let rulesKey in adminUserRules) {
                            let rulesValue = adminUserRules[rulesKey];
                            if (rulesValue['docTblAdminUserRulePK']['ruleId'] === formValue['ruleId']) {
                                formData[index] = Object.assign(this.state['formData'][index], { value: String(rulesValue['validFlg']) });
                                break;
                            }
                        }
                    } else {
                        let value = detail[index];
                        if (value !== undefined) {
                            if (['capacity'].includes(index)) {
                                value = ByteFormatToGB(value);
                            }
                            if (['managerCreateNum', 'deputyManagerCreateNum', 'userCreateNum'].includes(index)) {
                                if (checkInteger(value)) {
                                    value = String(value);
                                }
                            }

                            if (index === 'clientCode') {
                                formData[index] = Object.assign(this.state['formData'][index], { value: value, disabled: true });
                            } else {
                                formData[index] = Object.assign(this.state['formData'][index], { value: value });
                            }
                        }
                    }
                }

                let adminValue = detail['docTblAdminUser'];
                let adminUserCode = Object.assign(this.state['formData']['adminUserCode'], { value: adminValue['adminUserCode'], disabled: true });
                formData['adminUserCode'] = adminUserCode;

                let contactPersonName = Object.assign(this.state['formData']['contactPersonName'], { value: adminValue['name'] });
                formData['contactPersonName'] = contactPersonName;

                let email = Object.assign(this.state['formData']['email'], { value: adminValue['email'] });
                formData['email'] = email;

                let adminId = Object.assign(this.state['formData']['adminId'], { value: adminValue['adminId'] });
                formData['adminId'] = adminId;

                let langId = Object.assign(this.state['formData']['langId'], { value: adminValue['langId'] });
                formData['langId'] = langId;

                let langName = Object.assign(this.state['formData']['langName'], { value: this.state.langIdObj[adminValue['langId']] });
                formData['langName'] = langName;

                let contactLangId = Object.assign(this.state['formData']['contactLangId'], { value: detail['contactLangId'] });
                formData['contactLangId'] = contactLangId;

                let contactLangName = Object.assign(this.state['formData']['contactLangName'], { value: this.state.contactLangIdObj[detail['contactLangId']] });
                formData['contactLangName'] = contactLangName;

                this.setState({
                    loading: false,
                    formData: formData
                });
            })
        }
    }


    handleChange = (filed) => event => {
        // let filed = event.target.id || event.target.name;
        let formData = this.state.formData;
        if (filed === 'startTimeStr' || filed === 'endTimeStr') {
            let values = event;
            formData[filed] = Object.assign(this.state['formData'][filed], { value: values });
            this.setState({
                formData: formData
            });
        } else {
            if (filed === 'langId') {
                let valueName = this.state.langIdObj[event.target.value];
                formData[filed] = Object.assign(this.state['formData'][filed], { 'langName': Object.assign(this.state['formData']['langName'], { value: valueName }) });
                this.setState({
                    formData: formData
                });
            } else if (filed === 'contactLangId') {
                let valueName = this.state.langIdObj[event.target.value];
                formData[filed] = Object.assign(this.state['formData'][filed], { 'contactLangName': Object.assign(this.state['formData']['contactLangName'], { value: valueName }) });
                this.setState({
                    formData: formData
                });
            }
            let value = event.target.value;
            formData[filed] = Object.assign(this.state['formData'][filed], { value: value });
            this.setState({
                formData: formData
            });
        }

    };
    handleSubmit = () => {
        const descriptor = {
            clientCode: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.group_id),
                },
                {
                    max: 32,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.group_id)
                },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_en_num, this.state.dictWord.group_id),
                    validator(rule, value, callback, source, options) {
                        if (!/^[0-9a-zA-Z_/.-]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },

            ],
            name: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.company_name)
                },
                {
                    max: 100,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.company_name)
                },
            ],
            contactName: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.contact_name)
                },
                {
                    max: 100,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.contact_name)
                },
            ],
            contactEmail: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.contact_email)
                },
                {
                    max: 100,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.contact_email)
                },
                { type: "email", required: true, message: this.state.dictWord.msg_not_valid_mail_address },
            ],
            contactLangId: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.contact_set_lang) },
            ],
            phone: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.tel_no)
                },
                {
                    max: 128,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.tel_no)
                },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.tel_no),
                    validator(rule, value, callback, source, options) {
                        if (!/^[0-9-/]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
            ],
            fax: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.fax_no)
                },
                {
                    max: 50,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.fax_no)
                },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.fax_no),
                    validator(rule, value, callback, source, options) {
                        if (!/^[0-9-/]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
            ],
            zipCode: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.zip_code)
                },
                {
                    max: 20,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.zip_code)
                },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.zip_code),
                    validator(rule, value, callback, source, options) {
                        if (!/^[0-9-/]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
            ],
            address: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.address)
                },
                {
                    max: 200,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.address)
                },
            ],
            capacity: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.use_capacity)
                },
                {
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.use_capacity),
                    validator(rule, value, callback, source, options) {
                        if (!checkPNumber(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.use_capacity),
                    validator(rule, value, callback, source, options) {
                        if (!checkDecimal(ByteFormatToGB(value), [6, 2])) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    message: this.state.dictWord.msg_please_enter_integer_than_1,
                    validator(rule, value, callback, source, options) {
                        if (Number(value) < 0) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
            ],
            startTimeStr: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.service_start_date)
                },
            ],
            endTimeStr: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.service_end_date)
                },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_endate_greater_than_start_date, this.state.dictWord.service_end_date),

                    validator(rule, value, callback, source, options) {
                        if (value < source['startTimeStr']) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
            ],
            managerCreate: {},
            managerCreateNum: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.enterprise_managers_count)
                },
                {
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.enterprise_managers_count),
                    validator(rule, value, callback, source, options) {
                        if (!checkPNumber(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    message: this.state.dictWord.msg_please_enter_integer_than_1,
                    validator(rule, value, callback, source, options) {
                        if (!checkInteger(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    required: true,
                    message: this.state.dictWord.msg_please_enter_integer_than_1,
                    validator(rule, value, callback, source, options) {
                        if (Number(value) < 1) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    max: 11,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.enterprise_managers_count)
                },

            ],
            deputyManagerCreateNum: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.associate_managers_count)
                },
                {
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.associate_managers_count),
                    validator(rule, value, callback, source, options) {
                        if (!checkPNumber(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    message: this.state.dictWord.msg_please_enter_integer_than_0,
                    validator(rule, value, callback, source, options) {
                        if (!checkInteger(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    required: true,
                    message: this.state.dictWord.msg_please_enter_integer_than_0,
                    validator(rule, value, callback, source, options) {
                        if (Number(value) < 0) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    max: 11,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.associate_managers_count)
                },

            ],
            userCreateNum: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.user_count)
                },
                {
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.user_count),
                    validator(rule, value, callback, source, options) {
                        if (!checkPNumber(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    message: this.state.dictWord.msg_please_enter_integer_than_0,
                    validator(rule, value, callback, source, options) {
                        if (!checkInteger(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    required: true,
                    message: this.state.dictWord.msg_please_enter_integer_than_0,
                    validator(rule, value, callback, source, options) {
                        if (Number(value) < 0) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    max: 11,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.user_count)
                },
            ],
            adminUserCode: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.enterprise_managers_id)
                },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_en_num, this.state.dictWord.enterprise_managers_id),
                    validator(rule, value, callback, source, options) {
                        if (!/^[0-9a-zA-Z_/.-]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    max: 32,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.enterprise_managers_id)
                },
            ],
            contactPersonName: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.contact_person_name)
                },
                {
                    max: 100,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.contact_person_name)
                },
            ],
            email: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.email)
                },
                { type: "email", required: true, message: this.state.dictWord.msg_not_valid_mail_address },
                {
                    max: 50,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.email)
                },
            ],
            langId: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.set_lang) },
            ],
        }
        const validator = new schema(descriptor);
        let resource = {
            adminUserRules: [], docTblAdminUser: {
                adminUserCode: this.state.formData.adminUserCode.value,
                adminId: this.state.formData.adminId.value,
                name: this.state.formData.contactPersonName.value,
                email: this.state.formData.email.value,
                langId: parseInt(this.state.formData.langId.value)
            }
        };
        const formData = this.state.formData;
        for (let index in formData) {
            let item = formData[index];
            let value = item.value;
            if (['capacity'].includes(index)) {
                if (checkPNumber(value)) {
                    value = GBFormatToByte(value);
                }
            }
            if (['startTimeStr', 'endTimeStr'].includes(index)) {
                value = value ? dateFormat(new Date(value), 'yyyy/MM/dd') : ''
            }
            resource[index] = value;
            if (item['ruleId']) {
                resource['adminUserRules'].push({
                    ruleId: item.ruleId,
                    validFlg: item.value
                });
            }
        }

        validator.validate(resource, {
            firstFields: true
        }, (errors, fields) => {
            let formData = this.state.formData;
            let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
            let emojierr = [];
            for (let index in formData) {
                formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false })
                let value = formData[index].value;
                if (value && typeof value !== 'object' && value.length > 0) {
                    if (value.search(emojiReg) >= 0) {
                        emojierr.push({ 'message': this.state.dictWord.msg_error_value_invalid, 'field': index });
                    }
                }
            }
            if (errors || emojierr.length > 0) {
                if (errors) {
                    errors.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                if (emojierr.length > 0) {
                    emojierr.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                this.setState({
                    formData: formData
                });
            } else {
                this.setState({
                    formData: formData
                });
                let pathname = '/admin/management/client_confirm';
                if (this.props.match.params.id !== undefined) {
                    pathname += '/' + this.props.match.params.id;
                }
                this.props.history.push({
                    pathname: pathname,
                    query: resource
                })
            }
        })
    }
    clearStartTime = () => {
        let formData = this.state.formData;
        formData['startTimeStr'] = Object.assign(this.state['formData']['startTimeStr'], { value: null });
        this.setState({
            formData: formData
        });
    }
    clearEndTime = () => {
        let formData = this.state.formData;
        formData['endTimeStr'] = Object.assign(this.state['formData']['endTimeStr'], { value: null });
        this.setState({
            formData: formData
        });
    }
    render() {
        const { classes } = this.props;
        const { dictWord, formData } = this.state;
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {dictWord.group_id}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.clientCode.error} fullWidth>
                            <InputBase
                                id="clientCode"
                                value={formData.clientCode.value}
                                onChange={this.handleChange('clientCode')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                fullWidth
                                error={formData.clientCode.error}
                                disabled={formData.clientCode.disabled}
                            />
                            {formData.clientCode.error ? <FormHelperText id="clientCode-error-text">{formData.clientCode.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="name">
                            {dictWord.company_name}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.name.error} fullWidth>
                            <InputBase
                                id="name"
                                value={formData.name.value}
                                onChange={this.handleChange('name')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                fullWidth
                            />
                            {formData.name.error ? <FormHelperText id="name-error-text">{formData.name.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contactName">
                            {dictWord.contact_name}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.contactName.error} fullWidth>
                            <InputBase
                                id="contactName"
                                value={formData.contactName.value}
                                onChange={this.handleChange('contactName')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                fullWidth
                            />
                            {formData.contactName.error ? <FormHelperText id="contactName-error-text">{formData.contactName.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contactEmail">
                            {dictWord.contact_email}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.contactEmail.error} fullWidth>
                            <InputBase
                                id="contactEmail"
                                value={formData.contactEmail.value}
                                onChange={this.handleChange('contactEmail')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                fullWidth
                            />
                            {formData.contactEmail.error ? <FormHelperText id="contactEmail-error-text">{formData.contactEmail.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="langId">
                            {dictWord.contact_set_lang}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={formData.contactLangId.error} fullWidth>
                            <Select
                                value={formData.contactLangId.value}
                                onChange={this.handleChange('contactLangId')}
                                input={<BootstrapInput />}
                                error={this.state.formData.contactLangId.error}
                            >
                                <MenuItem value="" />
                                {this.state.langIdData.map((item, index) => {
                                    return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                })}
                            </Select>
                            {this.state.formData.contactLangId.error ? <FormHelperText id="contactLangId-error-text">{this.state.formData.contactLangId.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="phone">
                            {dictWord.tel_no}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={formData.phone.error} fullWidth>
                            <InputBase
                                value={formData.phone.value}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                onChange={this.handleChange('phone')}
                                fullWidth
                            />
                            {formData.phone.error ? <FormHelperText id="phone-error-text">{formData.phone.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="fax">
                            {dictWord.fax_no}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={formData.fax.error} fullWidth>
                            <InputBase
                                value={formData.fax.value}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                onChange={this.handleChange('fax')}
                                fullWidth
                            />
                            {formData.fax.error ? <FormHelperText id="fax-error-text">{formData.fax.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="zipCode">
                            {dictWord.zip_code}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={formData.zipCode.error} fullWidth>
                            <InputBase
                                id="zipCode"
                                value={formData.zipCode.value}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                onChange={this.handleChange('zipCode')}
                                // inputComponent={zipCodeMaskCustom}
                                fullWidth
                            />
                            {formData.zipCode.error ? <FormHelperText id="zipCode-error-text">{formData.zipCode.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="address">
                            {dictWord.address}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.address.error} fullWidth>
                            <InputBase
                                id="address"
                                value={formData.address.value}
                                onChange={this.handleChange('address')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                fullWidth
                            />
                            {formData.address.error ? <FormHelperText id="address-error-text">{formData.address.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="capacity">
                            {dictWord.use_capacity}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={formData.capacity.error} fullWidth>
                            <InputBase
                                id="capacity"
                                // type="number"
                                value={formData.capacity.value}
                                onChange={this.handleChange('capacity')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                fullWidth
                                endAdornment="GB"
                                style={{ width: '50%' }}
                            />
                            {formData.capacity.error ? <FormHelperText id="capacity-error-text">{formData.capacity.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="startTimeStr">
                            {dictWord.service_start_date}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={formData.startTimeStr.error}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                <div className="picker">
                                    <DatePicker ampm="false" name="startTimeStr" format="yyyy/MM/dd" value={formData.startTimeStr.value} onChange={this.handleChange('startTimeStr')} />
                                    <Clear onClick={this.clearStartTime} />
                                </div>
                            </MuiPickersUtilsProvider>
                            {formData.startTimeStr.error ? <FormHelperText id="startTimeStr-error-text">{formData.startTimeStr.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="endTimeStr">
                            {dictWord.service_end_date}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={formData.endTimeStr.error}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                <div className="picker">
                                    <DatePicker ampm="false" name="endTimeStr" format="yyyy/MM/dd" value={formData.endTimeStr.value} onChange={this.handleChange('endTimeStr')} />
                                    <Clear onClick={this.clearEndTime} />
                                </div>
                            </MuiPickersUtilsProvider>
                            {formData.endTimeStr.error ? <FormHelperText id="endTimeStr-error-text">{formData.endTimeStr.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="managerCreate-input">
                            {dictWord.enterprise_managers_generate}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="managerCreate"
                            name="managerCreate"
                            value={formData.managerCreate.value}
                            onChange={this.handleChange('managerCreate')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="managerCreateNum">
                            {dictWord.enterprise_managers_count}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.managerCreateNum.error} fullWidth>
                            <InputBase
                                id="managerCreateNum"
                                value={formData.managerCreateNum.value}
                                onChange={this.handleChange('managerCreateNum')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                style={{ width: '15%' }}
                            />
                            {formData.managerCreateNum.error ? <FormHelperText id="managerCreateNum-error-text">{formData.managerCreateNum.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="deputyManagerCreate">
                            {dictWord.associate_managers_generate}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            id="deputyManagerCreate"
                            aria-label="position"
                            name="deputyManagerCreate"
                            value={formData.deputyManagerCreate.value}
                            onChange={this.handleChange('deputyManagerCreate')}
                            row
                        >
                            <FormControlLabel value="1" control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end" />
                            <FormControlLabel value="0" control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end" />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="deputyManagerCreateNum">
                            {dictWord.associate_managers_count}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.deputyManagerCreateNum.error} fullWidth>
                            <InputBase
                                id="deputyManagerCreateNum"
                                value={formData.deputyManagerCreateNum.value}
                                onChange={this.handleChange('deputyManagerCreateNum')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                style={{ width: '15%' }}
                            />
                            {formData.deputyManagerCreateNum.error ? <FormHelperText id="deputyManagerCreateNum-error-text">{formData.deputyManagerCreateNum.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userCreate">
                            {dictWord.user_generate}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            id="userCreate"
                            aria-label="position"
                            name="userCreate"
                            value={formData.userCreate.value}
                            onChange={this.handleChange('userCreate')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                            />
                            <FormControlLabel value="0" control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end" />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userCreateNum">
                            {dictWord.user_count}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={formData.userCreateNum.error} fullWidth>
                            <InputBase
                                id="userCreateNum"
                                value={formData.userCreateNum.value}
                                onChange={this.handleChange('userCreateNum')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                style={{ width: '15%' }}
                            />
                            {formData.userCreateNum.error ? <FormHelperText id="userCreateNum-error-text">{formData.userCreateNum.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="departmentManagementAuth">
                            {dictWord.department_management_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            id="departmentManagementAuth"
                            aria-label="position"
                            name="departmentManagementAuth"
                            value={formData.departmentManagementAuth.value}
                            onChange={this.handleChange('departmentManagementAuth')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="categoryManagementAuth">
                            {dictWord.category_management_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            id="categoryManagementAuth"
                            aria-label="position"
                            name="categoryManagementAuth"
                            value={formData.categoryManagementAuth.value}
                            onChange={this.handleChange('categoryManagementAuth')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="newsRelease">
                            {dictWord.notification_release}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            id="newsRelease"
                            aria-label="position"
                            name="newsRelease"
                            value={formData.newsRelease.value}
                            onChange={this.handleChange('newsRelease')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="pushNotice">
                            {dictWord.push_notice}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            id="pushNotice"
                            name="pushNotice"
                            value={formData.pushNotice.value}
                            onChange={this.handleChange('pushNotice')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contentRegistrationAuth">
                            {dictWord.content_registration_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="contentRegistrationAuth"
                            id="contentRegistrationAuth"
                            value={formData.contentRegistrationAuth.value}
                            onChange={this.handleChange('contentRegistrationAuth')}
                            row
                        >
                            <FormControlLabel
                                value="1" control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="deviceControl">
                            {dictWord.device_control}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <RadioGroup
                            aria-label="position"
                            id="deviceControl"
                            name="deviceControl"
                            value={formData.deviceControl.value}
                            onChange={this.handleChange('deviceControl')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contentMultipleRegistration">
                            {dictWord.content_multiple_registration}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="contentMultipleRegistration"
                            id="contentMultipleRegistration"
                            value={formData.contentMultipleRegistration.value}
                            onChange={this.handleChange('contentMultipleRegistration')}
                            row
                        >
                            <FormControlLabel value="1"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="logExport">
                            {dictWord.log_export}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <RadioGroup
                            aria-label="position"
                            id="logExport"
                            name="logExport"
                            value={formData.logExport.value}
                            onChange={this.handleChange('logExport')}
                            row
                        >
                            <FormControlLabel value="1"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="applicationImport">
                            {dictWord.application_import}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="applicationImport"
                            id="applicationImport"
                            value={formData.applicationImport.value}
                            onChange={this.handleChange('applicationImport')}
                            row
                        >
                            <FormControlLabel value="1"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="activeDirectory">
                            {dictWord.active_directory_setting}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="activeDirectory"
                            id="activeDirectory"
                            value={formData.activeDirectory.value}
                            onChange={this.handleChange('activeDirectory')}
                            row
                        >
                            <FormControlLabel value="1"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contentUpdateEmailDelivery">
                            {dictWord.content_update_email_delivery}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="contentUpdateEmailDelivery"
                            id="contentUpdateEmailDelivery"
                            value={formData.contentUpdateEmailDelivery.value}
                            onChange={this.handleChange('contentUpdateEmailDelivery')}
                            row
                        >
                            <FormControlLabel value="1"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor=" contentUpdatePushDelivery ">
                            {dictWord.content_update_push_delivery}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="contentUpdatePushDelivery"
                            id="contentUpdatePushDelivery"
                            value={formData.contentUpdatePushDelivery.value}
                            onChange={this.handleChange('contentUpdatePushDelivery')}
                            row
                        >
                            <FormControlLabel value="1"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.valid} labelPlacement="end"
                            />
                            <FormControlLabel value="0"
                                control={<Radio className={classes.Radio} color="primary" />} label={dictWord.invalid} labelPlacement="end"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="passValidTimeFlg">
                            {dictWord.managers_password_expires_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Select
                            value={formData.passValidTimeFlg.value}
                            onChange={this.handleChange('passValidTimeFlg')}
                            id="passValidTimeFlg"
                            name="passValidTimeFlg"
                            input={<BootstrapInput />}
                            style={{ width: formData.passValidTimeFlg.width }}
                        >
                            {this.state.passValidTimeFlg.map((item, index) => {
                                return <MenuItem key={index} value={index}>{dictWord[item]}</MenuItem>
                            })}
                        </Select>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="loginKeepTimeFlg">
                            {dictWord.managers_login_save_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Select
                            value={formData.loginKeepTimeFlg.value}
                            onChange={this.handleChange('loginKeepTimeFlg')}
                            id="loginKeepTimeFlg"
                            name="loginKeepTimeFlg"
                            input={<BootstrapInput />}
                            style={{ width: formData.loginKeepTimeFlg.width }}
                        >
                            {this.state.loginKeepTimeFlg.map((item, index) => {
                                return <MenuItem key={index} value={index}>{dictWord[item]}</MenuItem>
                            })}
                        </Select>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userPassValidTimeFlg">
                            {dictWord.user_password_expires_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Select
                            value={formData.userPassValidTimeFlg.value}
                            onChange={this.handleChange('userPassValidTimeFlg')}
                            id="userPassValidTimeFlg"
                            name="userPassValidTimeFlg"
                            input={<BootstrapInput />}
                            style={{ width: formData.userPassValidTimeFlg.width }}
                        >
                            {this.state.userPassValidTimeFlg.map((item, index) => {
                                return <MenuItem key={index} value={index}>{dictWord[item]}</MenuItem>
                            })}
                        </Select>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userLoginKeepTimeFlg">
                            {dictWord.user_login_save_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Select
                            value={formData.userLoginKeepTimeFlg.value}
                            onChange={this.handleChange('userLoginKeepTimeFlg')}
                            id="userLoginKeepTimeFlg"
                            name="userLoginKeepTimeFlg"
                            input={<BootstrapInput />}
                            style={{ width: formData.userLoginKeepTimeFlg.width }}
                        >
                            {this.state.userLoginKeepTimeFlg.map((item, index) => {
                                return <MenuItem key={index} value={index}>{dictWord[item]}</MenuItem>
                            })}
                        </Select>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="adminUserCode">
                                {dictWord.enterprise_managers_id}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl error={formData.adminUserCode.error} fullWidth>
                                <InputBase
                                    id="adminUserCode"
                                    value={formData.adminUserCode.value}
                                    onChange={this.handleChange('adminUserCode')}
                                    classes={{
                                        root: classes.bootstrapRoot,
                                        input: classes.bootstrapInput,
                                    }}
                                    fullWidth
                                    disabled={formData.adminUserCode.disabled}
                                />
                                {formData.adminUserCode.error ? <FormHelperText id="adminUserCode-error-text">{formData.adminUserCode.errorMsg}</FormHelperText> : ''}
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="contactPersonName">
                                {dictWord.contact_person_name}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl error={formData.contactPersonName.error} fullWidth>
                                <InputBase
                                    id="contactPersonName"
                                    value={formData.contactPersonName.value}
                                    onChange={this.handleChange('contactPersonName')}
                                    classes={{
                                        root: classes.bootstrapRoot,
                                        input: classes.bootstrapInput,
                                    }}
                                    fullWidth
                                />
                                {formData.contactPersonName.error ? <FormHelperText id="contactPersonName-error-text">{formData.contactPersonName.errorMsg}</FormHelperText> : ''}
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="email">
                                {dictWord.email}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>

                            <FormControl error={formData.email.error} fullWidth>
                                <InputBase
                                    id="email"
                                    value={formData.email.value}
                                    onChange={this.handleChange('email')}
                                    classes={{
                                        root: classes.bootstrapRoot,
                                        input: classes.bootstrapInput,
                                    }}
                                    fullWidth
                                />
                                {formData.email.error ? <FormHelperText id="email-error-text">{formData.email.errorMsg}</FormHelperText> : ''}
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="langId">
                                {dictWord.set_lang}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl error={this.state.formData.langId.error} fullWidth>
                                <Select
                                    value={this.state.formData.langId.value}
                                    onChange={this.handleChange('langId')}
                                    id="langId"
                                    name="langId"
                                    input={<BootstrapInput />}
                                    error={this.state.formData.langId.error}
                                >
                                    <MenuItem value="" />
                                    {this.state.langIdData.map((item, index) => {
                                        return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                    })}
                                </Select>
                                {this.state.formData.langId.error ? <FormHelperText id="langId-error-text">{this.state.formData.langId.errorMsg}</FormHelperText> : ''}
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container id="buttonNode" className={classes.margin}>
                    <Grid item xs={12} md={12} className={classes.bootstrapFormLabel}>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}>{dictWord.confirmation}</Button>
                        <Link to="/admin/management/client" className={classes.buttonLink}>
                            <Button variant="contained" color="primary" type="reset" className={classes.button}>{dictWord.cancel}</Button>
                        </Link>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

Client_Add.propTypes = {
    classes: PropTypes.object.isRequired,
};

// export default withStyles(styles)(Client_Add);
// export default connect(
//     mapStateToProps
// )(Client_Add)

export default compose(
    withStyles(styles, { name: 'Client_Add' }),
    connect(mapStateToProps, null)
)(Client_Add)
